import { all } from "redux-saga/effects";
import authSagas from "./Auth";
import contactSagas from "./Contact";
import missingSaga from "./Missing";
import etcMissingSaga from "./EtcMissing";
import foundSaga from "./Found";
import adminSaga from "./Admin";
import paymentSaga from "./Payment";

export default function* rootSaga(getState) {
  yield all([authSagas(), contactSagas(), missingSaga(), etcMissingSaga(), foundSaga(), adminSaga(), paymentSaga()]);
}
